import { NotificaUtenteResponseDTO } from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { Drawer, PaginationSimple } from '@framework/ui';
import { Space } from 'antd';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';
import { NotificationList } from './NotificationList';
import { NotificationFilterSwitch } from './detail/NotificationFilterSwitch';

const NotificationsDrawerBase = styled(Drawer)`
  .ant-drawer-content-wrapper {
    width: 600px !important;
    max-width: 70%;
    ${down('sm')} {
      width: 100% !important;
      max-width: 100%;
    }
  }

  .ant-drawer-header {
    padding: 10px;
  }
  .ant-drawer-body {
    padding: 0;
  }
  .ant-drawer-title {
    line-height: 1.3;
  }
`;

export interface INotificationsDrawerProps {
  handleClose: () => void;
  visible: boolean;
  filterToRead?: boolean;
  setFilterToRead: (value: boolean | undefined) => void;
  setPage: (page: number) => void;
  total: number;
  page: number;
  pageSize: number;
  notifications: NotificaUtenteResponseDTO[] | null | undefined;
  apiResult: any;
  id?: string;
}

/**
 * Drawer delle notifiche
 */
export function NotificationsDrawer(props: INotificationsDrawerProps) {
  const {
    handleClose,
    visible,
    filterToRead,
    setFilterToRead,
    setPage,
    notifications,
    apiResult,
    total,
    page,
    pageSize,
    id,
  } = props;

  const { t } = useTranslation();

  return (
    <NotificationsDrawerBase
      id={id}
      title={t('notification-drawer.title', 'Notifiche')}
      placement="right"
      onClose={handleClose}
      // visible={visible}
      open={visible}
      extra={
        <Space>
          <NotificationFilterSwitch
            defaultChecked={filterToRead === false ? true : false}
            onChange={value => {
              // Seleziona solo quelle da leggere, altrimenti tutte
              setFilterToRead(value ? false : undefined);
              setPage(1);
            }}
          />
          <PaginationSimple
            total={total}
            current={page}
            pageSize={pageSize}
            onChange={page => {
              setPage(page);
            }}
          />
        </Space>
      }
      key="notificaion-drawer"
    >
      <NotificationList list={notifications} loading={apiResult.isLoading} />
    </NotificationsDrawerBase>
  );
}
